
import Product from "components/Productdetail/Product";

import Badges from "views/Badges/Badges";

import Myproducts from "views/Myproducts/Myproducts";

import Dashboard from "views/dashboard/Dashboard.js";

import Usersdetail from "views/Myproducts/Usersdetail";
import Addnewproduct from "components/Addnewproduct/Addnewproduct";
import Editprofile from "components/Editprofile/Editprofile";


var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/myproducts",
    name: "Users",
    component: Myproducts,
    layout: "/admin",
  },
  {
    path: "/usersdetail",
    name: "Users detail",
    component: Usersdetail,
    layout: "/admin",
  },



  {
    path: "/productdetail",
    name: "Product Details",
    component: Product,
    layout: "/admin",
  },
  {
    path: "/badgesandpoints",
    name: "Projects",
    component: Badges,
    layout: "/admin",
  },
  {
    path: "/addnewproduct",
    name: "Create Project",
    component: Addnewproduct,
    layout: "/admin",
  },

  // {
  //   path: "/editprofile",
  //   name: "Edit Profile",
  //   component: Editprofile,
  //   layout: "/admin",
  // },

];
export default routes;